import { useEffect, useState } from "react"
import styled from "styled-components"
import { MovieElementDiv, slugify } from "../../Components/MoviesSlider"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { AddBannerDiv } from "../Home"
import AdsterraBanner from "../../Components/AdsterraBanner"
import ExoClickBanner728x90 from "../../Components/ExoClickBanner728x90"
import ExoClickBannerMobile from "../../Components/ExoClickBannerMobile"
import AdsterraNativeBanner from "../../Components/AdsterraNativeBanner"

const ActRealMoviesDiv = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    max-width: 100%;
    position: relative;
    border-radius: 15px;
    padding: 100px 120px;
    @media screen and (max-width: 1024px) {
        padding: 100px 10px;
    }

    > h2 {
        margin: 0 0 10px 0;
        font-size: 1.7em;
        @media screen and (max-width: 1024px) {
            font-size: 1.4em;
        }
    }
`
const ContainerDiv = styled.div`
    justify-content: flex-start;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 40px;
`

function ActRealPage() {
    const [actRealMovies, setActRealMovies] = useState([])
    const [actRealSeries, setActRealSeries] = useState([])

    const location = useLocation()
    //const [searchParams] = useSearchParams()
    const { colone } = useParams()
    const { name } = location.state || {}

    const fetchActReal = async (colone, name) => {
        try {
            const API_BASE =
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:8787"
                    : window.location.origin

            const response = await fetch(
                `${API_BASE}/api/act-real?colone=${colone}&name=${name}`,
            )
            const json = await response.json()
            setActRealMovies(json.films)
            setActRealSeries(json.series)
        } catch (error) {
            console.log("Fetch error: ", error)
        }
    }

    useEffect(() => {
        fetchActReal(colone.toString(), name.toString())
        document.title = `${
            name ?? colone
        } | Films et Series en streaming complet`
    }, [name, colone])

    function toArray(data) {
        if (Array.isArray(data)) return data
        if (data == null) return []
        return [data]
    }

    const navigate = useNavigate()
    const movieHandleClick = (type, id, titre) => {
        const urlTitle = slugify(titre)

        if (type === "film") {
            navigate(`/film/${urlTitle}?film_id=${id}`)
        } else if (type === "serie") {
            navigate(`/serie/${urlTitle}?serie_id=${id}`)
        }
    }

    const isMobile = window.innerWidth < 768

    return (
        <ActRealMoviesDiv>
            {/*<AddBannerDiv>
                {isMobile ? <ExoClickBannerMobile /> : <ExoClickBanner728x90 />}
            </AddBannerDiv>*/}

            <h2
                style={{
                    display: !actRealMovies.length ? "none" : "initial",
                }}
            >
                Films
            </h2>
            <ContainerDiv
                style={{ display: !actRealMovies.length ? "none" : "flex" }}
            >
                {toArray(actRealMovies[0]).map(({ id, titre, cover }) => (
                    <MovieElementDiv
                        key={id}
                        onClick={() => {
                            movieHandleClick("film", id, titre)
                        }}
                    >
                        <img src={cover} alt="Movies cover" />
                        <p>{titre}</p>
                    </MovieElementDiv>
                ))}
            </ContainerDiv>

            <h2
                style={{
                    display: !actRealSeries.length ? "none" : "initial",
                }}
            >
                Series
            </h2>
            <ContainerDiv
                style={{ display: !actRealSeries.length ? "none" : "flex" }}
            >
                {toArray(actRealSeries[0]).map(({ id, titre, cover }) => (
                    <MovieElementDiv
                        key={id}
                        onClick={() => {
                            movieHandleClick("serie", id, titre)
                        }}
                    >
                        <img src={cover} alt="Movies cover" />
                        <p>{titre}</p>
                    </MovieElementDiv>
                ))}
            </ContainerDiv>

            <AddBannerDiv>
                <p>
                    Cliquer sur les pub est le meilleur moyen de nous soutenir
                </p>
                {isMobile ? (
                    <AdsterraBanner
                        keyId="0ce49bfc0a6847270e97cef8117bdaff"
                        width={468}
                        height={60}
                    />
                ) : (
                    <AdsterraNativeBanner />
                )}
            </AddBannerDiv>

            {/*<AddBannerDiv>
                <p>
                    Cliquer sur les pub est le meilleur moyen de nous soutenir
                </p>
                {isMobile ? (
                    <AdsterraBanner
                        keyId="36095d1eafe994c25e794db19ac32ddd"
                        width={320}
                        height={50}
                    />
                ) : (
                    <AdsterraBanner
                        keyId="dcfa5d9b41f84b62a0d227806e4b1618"
                        width={728}
                        height={90}
                    />
                )}
            </AddBannerDiv>*/}
        </ActRealMoviesDiv>
    )
}

export default ActRealPage
